import Http from '../http'
// 运营管理模块API
export default {
  // ----------------在线终端 begin -----------------
  // 在线终端
  getOnlineDev(params) {
    return Http.post('/device/online.do', params)
  },
  // 未注册终端
  getUnRegister(params) {
    return Http.post('device/unreg.do', params)
  },
  // 冲突终端
  getConflictDev(params) {
    return Http.post('/device/conflictDev.do', params)
  },
  // 获取单个未注册终端
  getSingleUnRegister(params) {
    return Http.post('device/getUnreg.do', params)
  },
  // 保存单个未注册终端
  saveSingleUnRegister(params) {
    return Http.post('device/addUnreg.do', params)
  },
  // 保存多个未注册终端
  saveBatchUnRegister(params) {
    return Http.post('device/batchUnreg.do', params)
  },
  // 在线客户
  getOnlineClient(params) {
    return Http.post('device/client.do', params)
  },
  // ----------------在线终端 end -----------------
  // ----------------终端管理(admin) begin -----------------
  // 终端管理---所有终端、库存终端、天后欠费终端、30天后欠费终端、已欠费终端 传入参数不一样
  getDevice(params) {
    return Http.post('device/list.do', params)
  },
  // 保存添加单个终端
  saveAddSingleDev(params) {
    return Http.post('device/add.do', params)
  },
  // 保存批量添加终端
  saveBatchAddDev(params) {
    return Http.post('device/batchAdd.do', params)
  },
  // 导入
  importExcel(params) {
    return '/device/importExcel.do'
  },
  // 保存编辑终端(admin账号)
  saveAdminEditDev(params) {
    return Http.post('device/save.do', params)
  },
  // 保存编辑终端(非admin账号)
  saveEditDev(params) {
    return Http.post('device/save.do', params)
  },
  // 获取车辆品牌列表
  getBrandList(params) {
    return Http.post('vehicle/listBrand.do', params)
  },
  // 获取单个车辆品牌
  getSingleBrand(params) {
    return Http.post('vehicle/getBrand.do', params)
  },
  // 保存添加车辆品牌
  saveAddBrand(params) {
    return Http.post('vehicle/addBrand.do', params)
  },
  // 保存编辑车辆品牌
  saveEditBrand(params) {
    return Http.post('vehicle/editBrand.do', params)
  },
  // 删除车辆品牌
  deleteBrand(params) {
    return Http.post('vehicle/delBrand.do', params)
  },
  // 获取单个车辆类型
  getSingleBrandType(params) {
    return Http.post('vehicle/getType.do', params)
  },
  // 保存添加车辆类型
  saveAddBrandType(params) {
    return Http.post('vehicle/addType.do', params)
  },
  // 保存编辑车辆类型
  saveEditBrandType(params) {
    return Http.post('vehicle/editType.do', params)
  },
  // 删除车辆类型
  deleteBrandType(params) {
    return Http.post('vehicle/delType.do', params)
  },
  // 一周内到期车辆年检终端
  getDevInspection(params) {
    return Http.post('/device/inspection.do', params)
  },
  // 启用续费的设备
  getDevPay(params) {
    return Http.post('/device/devPay.do', params)
  },
  // ----------------终端管理(admin) end -----------------
  // ----------------终端管理(二级账号) begin -----------------
  // 获取终端列表
  getSecondDevice(params) {
    return Http.post('vehicle/list.do', params)
  },
  // 导出终端
  exportSecondDevice() {
    return '/export/vehicleList.do?'
  },
  // 获取复制参数、编辑终端数据
  getCopyParams(params) {
    return Http.post('vehicle/get.do', params)
  },
  // 保存复制参数
  saveCopyParams(params) {
    return Http.post('vehicle/copy.do', params)
  },
  // 查看授权
  checkAuth(params) {
    return Http.post('vehicle/permit.do', params)
  },
  // 删除授权用户
  deleteAuthUser(params) {
    return Http.post('vehicle/delPermit.do', params)
  },
  // ----------------终端管理(二级账号) end -----------------
  // ----------------司机管理 begin -----------------
  // 获取司机列表
  getDriverList(params) {
    // return Http.post('driver/list.do', params)
    return Http.post('driverinfo/list.do', params)
  },
  // 添加司机
  addDriver(params) {
    // return Http.post('driver/add.do', params)
    return Http.post('driverinfo/add.do', params)
  },
  // 保存编辑司机
  saveDriver(params) {
    // return Http.post('driver/save.do', params)
    return Http.post('driverinfo/update.do', params)
  },
  // 删除司机
  deleteDriver(params) {
    // return Http.post('driver/delete.do', params)
    return Http.post('driverinfo/deleteByIds.do', params)
  },
  // 获取单个司机信息
  getSingleDriver(params) {
    // return Http.post('driver/get.do', params)
    return Http.post('driverinfo/get.do', params)
  },
  // 添加司机关联设备
  addRelDevice(params) {
    // return Http.post('driver/get.do', params)
    return Http.post('driverinfo/addVehicleRel.do', params)
  },
  // 删除司机关联设备
  delRelDevice(params) {
    // return Http.post('driver/get.do', params)
    return Http.post('driverinfo/removeVehicleRel.do', params)
  },
  // 设置司机主副驾
  setDriverType(params) {
    return Http.post('/driverinfo/updateDriverType.do', params)
  },
  // 司机签到
  driverSignIn(params) {
    return Http.post('driverinfo/signs.do', params)
  },
  // ----------------司机管理 end -----------------
  // ----------------公司信息 begin -----------------
  // 获取公司列表
  getCompanyList(params) {
    return Http.post('user/list.do', params)
  },
  // 保存添加公司
  addCompany(params) {
    return Http.post('user/add.do', params)
  },
  // 保存编辑公司
  saveCompany(params) {
    return Http.post('user/save.do', params)
  },
  // 删除公司
  deleteCompany(params) {
    return Http.post('user/delete.do', params)
  },
  // 解锁密码
  unlockPassword(params) {
    return Http.post('user/unlockPassword.do', params)
  },
  // 获取单个公司信息
  getSingleCompany(params) {
    return Http.post('user/get.do', params)
  },
  // 重置密码
  resetPW(params) {
    return Http.post('user/reset.do', params)
  },
  // 删除终端
  deleteDevice(params) {
    return Http.post('device/delete.do', params)
  },
  // 导出终端
  exportDevice() {
    return '/device/exportExcel.do?'
  },
  // 获取单个设备信息
  getSingleDevice(params) {
    return Http.post('device/getSale.do', params)
  },
  // 销售终端
  saleDevice(params) {
    return Http.post('device/sale.do', params)
  },
  // ----------------公司信息 end -----------------
  // ----------------司机管理 begin2 -----------------
  // 获取司机列表
  getDriverList2(params) {
    return Http.post('driver/list.do', params)
  },
  // 添加司机
  addDriver2(params) {
    return Http.post('driver/add.do', params)
  },
  // 保存编辑司机
  saveDriver2(params) {
    return Http.post('driver/save.do', params)
  },
  // 删除司机
  deleteDriver2(params) {
    return Http.post('driver/delete.do', params)
  },
  // 获取单个司机信息
  getSingleDriver2(params) {
    return Http.post('driver/get.do', params)
  },
  // ----------------司机管理 end2 -----------------
  // ----------------用户管理 begin -----------------
  // 获取用户管理列表
  getUserList(params) {
    return Http.post('clients/list.do', params)
  },
  // 保存添加用户
  addUser(params) {
    return Http.post('clients/add.do', params)
  },
  // 保存编辑用户
  saveUser(params) {
    return Http.post('clients/update.do', params)
  },
  // 删除用户管理
  deleteUser(params) {
    return Http.post('clients/delete.do', params)
  },
  // 获取单个用户信息
  getSingleUser(params) {
    return Http.post('clients/get.do', params)
  },
  // 修改用户密码
  modifyUserPW(params) {
    return Http.post('/clients/resetPwd.do', params)
  },
  // 获取终端授权
  getDevPermit(params) {
    return Http.post('/clients/getPermit.do', params)
  },
  // 保存终端授权
  saveDevPermit(params) {
    return Http.post('/clients/savePermit.do', params)
  },
  // ----------------用户管理 end -----------------
  // ----------------运营线路管理 begin -----------------
  // 获取运营线路管理列表
  getLinesList(params) {
    return Http.post('/operaLines/list.do', params)
  },
  // 保存添加运营线路
  addLines(params) {
    return Http.post('/operaLineInfo/add.do', params)
  },
  // 保存编辑运营线路
  saveLines(params) {
    return Http.post('/operaLineInfo/save.do', params)
  },
  // 删除运营线路
  deleteLines(params) {
    return Http.post('/operaLineInfo/delete.do', params)
  },
  // 获取单个运营线路
  getSingleLines(params) {
    return Http.post('/operaLineInfo/get.do', params)
  },
  // 获取终端授权
  getLinesPermit(params) {
    return Http.post('/operaLineInfo/getPermit.do', params)
  },
  // 保存终端授权
  saveLinesPermit(params) {
    return Http.post('/operaLineInfo/permitDve.do', params)
  },
  // 获取用户管理中未授权车辆
  getUnAuthDevice(params) {
    return Http.post('operaLineInfo/getUnauthorized.do', params)
  },
  getAuthDevice(params) {
    return Http.post('operaLineInfo/getPermits.do', params)
  },
  // 获取运营线路管理列表
  getLineDriverList(params) {
    return Http.post('/operaLines/driverList.do', params)
  },
  // ----------------运营线路 end -----------------
  // ----------------角色管理 begin -----------------
  // 获取角色列表
  getRoleList(params) {
    return Http.post('/role/list.do', params)
  },
  // 删除角色
  deleteRoleList(params) {
    return Http.post('/role/delete.do', params)
  },
  // 获取单个角色
  getSingleRole(params) {
    return Http.post('/role/get.do', params)
  },
  // 获取权限树数据
  getPriviData() {
    return Http.post('/role/serverConfig.do')
  },
  // 保存添加角色权限
  saveAddRole(params) {
    return Http.post('/role/add.do', params)
  },
  // 保存编辑角色权限
  saveEditRole(params) {
    return Http.post('/role/save.do', params)
  },
  // ----------------角色管理 end -----------------
  // ----------------学生管理 begin -----------------
  // 获取学生列表
  getStudentList(params) {
    return Http.post('/student/list.do', params)
  },
  // 获取班级列表
  getClassList() {
    return Http.post('/studentClass/classList.do')
  },
  // 获取单个学生信息
  getSingleStudent(params) {
    return Http.post('/student/get.do', params)
  },
  // 删除学生
  deleteStudent(params) {
    return Http.post('/student/delete.do', params)
  },
  // 保存添加学生
  saveAddStudent(params) {
    return Http.post('/student/add.do', params)
  },
  // 保存编辑学生
  saveEditStudent(params) {
    return Http.post('/student/save.do', params)
  },
  // 获取单个学校信息
  getSingleSchool(params) {
    return Http.post('/school/schoolGet.do', params)
  },
  // 保存编辑学校
  saveEditSchool(params) {
    return Http.post('/school/schoolSave.do', params)
  },
  // 保存添加学校
  saveAddSchool(params) {
    return Http.post('/school/schoolAdd.do', params)
  },
  // 删除学校
  deleteSchool(params) {
    return Http.post('/school/schoolDelete.do', params)
  },
  // 获取单个班级信息
  getSingleClass(params) {
    return Http.post('/studentClass/classGet.do', params)
  },
  // 保存添加班级
  saveAddClass(params) {
    return Http.post('/studentClass/classAdd.do', params)
  },
  // 保存编辑班级
  saveEditClass(params) {
    return Http.post('/studentClass/classSave.do', params)
  },
  // 删除班级
  deleteClass(params) {
    return Http.post('/studentClass/classDelete.do', params)
  },
  // ----------------学生管理 end -----------------
  // ----------------车队管理 begin -----------------
  // 保存添加车队
  saveAddFleet(params) {
    return Http.post('/group/add.do', params)
  },
  // 保存编辑车队
  saveEditFleet(params) {
    return Http.post('/group/edit.do', params)
  },
  // 删除分组
  deleteGroup(params) {
    return Http.post('/group/delete.do', params)
  },
  // 移动分组
  moveGroupToGroup(params) {
    return Http.post('/group/move.do', params)
  },
  // 未分组移入已分组
  moveUngroupToGroup(params) {
    return Http.post('/group/selectGroup.do', params)
  },
  // 移出分组
  removeFromGroup(params) {
    return Http.post('/group/removeGroup.do', params)
  },
  // ----------------车队管理 end -----------------
  // ----------------订阅者管理 begin -----------------
  // 我方订阅者登录列表
  getDatainteractUserList(params) {
    return Http.post('/datainteract/list.do', params)
  },
  // 获取单个订阅者信息
  getSingleSuscriber(params) {
    return Http.post('/datainteract/get.do', params)
  },
  // 添加订阅者登录信息
  addSuscriber(params) {
    return Http.post('/datainteract/add.do', params)
  },
  // 更新订阅者信息
  updateSuscriber(params) {
    return Http.post('/datainteract/update.do', params)
  },
  // 删除订阅者信息
  delSuscriber(params) {
    return Http.post('/datainteract/delete.do', params)
  },
  // ----------------订阅者管理 end -----------------
  // ----------------乘务员管理 begin -----------------
  // 乘务员信息列表
  getTrainmanList(params) {
    return Http.post('/attendant/list.do', params)
  },
  // 获取单个乘务员信息
  getSingleTrainman(params) {
    return Http.post('/attendant/get.do', params)
  },
  // 删除乘务员信息
  delTrainman(params) {
    return Http.post('/attendant/delete.do', params)
  },
  // 添加乘务员信息
  addTrainman(params) {
    return Http.post('/attendant/add.do', params)
  },
  // 更新乘务员信息
  updateTrainman(params) {
    return Http.post('/attendant/update.do', params)
  },
  // ----------------乘务员管理 end -----------------
  // ----------------电子运单管理 begin -----------------
  // 电子运单信息列表
  getWaybillList(params) {
    return Http.post('/wayBill/list.do', params)
  },
  // 获取单个电子运单信息
  getSingleWaybill(params) {
    return Http.post('/wayBill/get.do', params)
  },
  // 添加电子运单信息
  addWaybill(params) {
    return Http.post('/wayBill/add.do', params)
  },
  // 删除电子运单信息
  delWaybill(params) {
    return Http.post('/wayBill/delete.do', params)
  },
  // 更新电子运单信息
  updateWaybill(params) {
    return Http.post('/wayBill/save.do', params)
  },
  // ----------------电子运单管理 end -----------------
  // ----------------线路信息 begin -----------------
  getLineInfoList(params) {
    return Http.post('/lineInfo/list.do', params)
  },
  getSingleLineInfo(params) {
    return Http.post('/lineInfo/get.do', params)
  },
  addLineInfo(params) {
    return Http.post('/lineInfo/add.do', params)
  },
  updateLineInfo(params) {
    return Http.post('/lineInfo/save.do', params)
  },
  deleteLineInfo(params) {
    return Http.post('/lineInfo/delete.do', params)
  },
  // ----------------线路信息 end -----------------
  // ----------------过境处边界信息 begin -----------------
  getBorderInfoList(params) {
    return Http.post('/mapTransitborderInfo/list.do', params)
  },
  getSingleBorderInfo(params) {
    return Http.post('/mapTransitborderInfo/get.do', params)
  },
  addBorderInfo(params) {
    return Http.post('/mapTransitborderInfo/add.do', params)
  },
  updateBorderInfo(params) {
    return Http.post('/mapTransitborderInfo/update.do', params)
  },
  deleteBorderInfo(params) {
    return Http.post('/mapTransitborderInfo/delete.do', params)
  },
  // ----------------过境处边界信息 end -----------------
  // ----------------司机排班 begin -----------------
  getDriverscheduleList(params) {
    return Http.post('/driverSchedule/list.do', params)
  },
  getSingleDriverschedule(params) {
    return Http.post('/driverSchedule/get.do', params)
  },
  addDriverschedule(params) {
    return Http.post('/driverSchedule/add.do', params)
  },
  updateDriverschedule(params) {
    return Http.post('/driverSchedule/update.do', params)
  },
  deleteDriverschedule(params) {
    return Http.post('/driverSchedule/delete.do', params)
  },
  // ----------------司机排班 end -----------------
  // ----------------文件/广告管理 begin -----------------
  getFileList(params) { // 文件列表
    return Http.post('/taxi/getUpFiles.do', params)
  },
  getFileDeviceList(params) { // 设备文件列表
    return Http.post('/taxi/getDevUpFiles.do', params)
  },
  getAdvertiseList(params) { // 广告列表
    return Http.post('/taxi/getCmsFiles.do', params)
  },
  deleteTaxiFile(params) { // 删除文件
    return Http.post('/taxi/deleteByIds.do', params)
  },
  deleteTaxiCmsFile(params) { // 删除广告文件
    return Http.post('/taxi/deleteCmsById.do', params)
  },
  getSingleFileInfo(params) {
    return Http.post('/taxi/getFileInfo.do', params)
  },
  addFile(params) { // 添加文件保存
    return Http.post('/taxi/addFile.do', params)
  },
  addFilePermit(params) { // 添加文件保存
    return Http.post('/taxi/addFilePermit.do', params)
  },
  saveFile(params) { // 编辑文件保存
    return Http.post('/taxi/updateFile.do', params)
  },
  // ----------------文件/广告管理 end -----------------
  // ----------------SIM卡管理 begin -----------------
  // SIM卡列表
  getSIMCardList(params) {
    return Http.post('/simcard/list.do', params)
  },
  // 添加SIM卡
  addSIMCard(params) {
    return Http.post('/simCard/add.do', params)
  },
  // 删除SIM卡
  deleteSIMCard(params) {
    return Http.post('/simCard/delete.do', params)
  },
  // 修改SIM卡
  editSIMCard(params) {
    return Http.post('/simCard/save.do', params)
  },
  // 查看某个SIM卡记录
  getSingleSIMCard(params) {
    return Http.post('/simCard/get.do', params)
  },
  // ----------------SIM卡管理 end -----------------
  // 保存授权司机
  savePermit(params) {
    return Http.post('/driverinfo/savePermit.do', params)
  },
  // 常用报表-导出
  exportDriverstaxilist() {
    return '/export/driverstaxilist.do'
  },
  // 常用报表-导出
  exportDriverslist() {
    return '/export/driverslist.do'
  },
  // 文件版轨迹查询
  getGpsTrack(params) {
    return Http.post('/mobile/getGpsTrack.do', params)
  },
  // ----------------new公司信息 begin -----------------
  // 获取公司列表
  getNewCompanyList(params) {
    return Http.post('company/list.do', params)
  },
  // 保存添加公司
  addNewCompany(params) {
    return Http.post('company/add.do', params)
  },
  // 保存编辑公司
  saveNewCompany(params) {
    return Http.post('company/save.do', params)
  },
  // 删除公司
  deleteNewCompany(params) {
    return Http.post('company/delete.do', params)
  },
  // 获取单个公司信息
  getNewSingleCompany(params) {
    return Http.post('company/get.do', params)
  },
  // 获取公司信息
  getCompanyInfoList(params) {
    return Http.post('companyInfo/list.do', params)
  },
  // 保存授权车辆到公司
  permitCompany(params) {
    return Http.post('/vehicle/permitCompany.do', params)
  },
  // 添加公告
  addNotice(params) {
    return Http.post('/notice/add.do', params)
  },
  // 删除公告
  deleteNotice(params) {
    return Http.post('/notice/delete.do', params)
  },
  // 获取公告列表
  getNoticeList(params) {
    return Http.post('/notice/list.do', params)
  },
  // 获取单个公告信息
  getNotice(params) {
    return Http.post('/notice/get.do', params)
  },
  // 更新公告信息
  updateNotice(params) {
    return Http.post('/notice/update.do', params)
  },
  // 获取已授权公告用户
  hasRelationUser(params) {
    return Http.post('/notice/hasRelationUser.do', params)
  },
  // 获取未授权公告用户
  getNoRelationUser(params) {
    return Http.post('/notice/getNoRelationUser.do', params)
  },
  // 普通公告关联用户
  userNoticeRel(params) {
    return Http.post('/notice/userNoticeRel.do', params)
  },
  // 接收方显示公告列表
  getMyNoticeList(params) {
    return Http.post('/notice/mylist.do', params)
  },
  // 确定收到公告
  confirmNotice(params) {
    return Http.post('/notice/confirmNotice.do', params)
  },
  // 是否有未读的公告
  unreadNotice(params) {
    return Http.post('/notice/unreadNotice.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/operation.js